import { apiRequest } from "@/lib/api";
import type { ProjectPaymentMethod } from "@/lib/projects-clients";

export type DashboardRange = "this_week" | "this_month" | "last_30_days" | "last_six_months" | "custom";

export type DashboardResponse = {
  filters: {
    projectId?: string | null;
    range: DashboardRange;
    startDate: string;
    endDate: string;
  };
  role: "ADMIN" | "PM" | "FIELD";
  kpis: {
    pendingTickets: number;
    pendingValue: number;
    approvedValue: number;
    rejectedCount: number;
    avgApprovalTimeDays: number;
  };
  ticketFlowTrend: Array<{
    key: string;
    label: string;
    ticketsAdded: number;
    approved: number;
    rejected: number;
  }>;
  aging: Array<{
    key: "0-3h" | "3-12h" | "12-36h" | "36h+";
    label: string;
    count: number;
    value: number;
  }>;
  recentActivity: Array<{
    id: string;
    eventType: string;
    actorName?: string | null;
    happenedAt: string;
    ticket?: {
      id: string;
      ticketNumber: string;
      title: string;
      status:
        | "DRAFT"
        | "PENDING_APPROVAL"
        | "APPROVED"
        | "REJECTED"
        | "NEEDS_CLARIFICATION"
        | "ARCHIVED";
      project?: { id: string; name: string } | null;
    } | null;
    project?: { id: string; name: string } | null;
    payment?: {
      id: string;
      amount: number;
      method: ProjectPaymentMethod;
      clientName?: string | null;
    } | null;
    schedule?: {
      clientName?: string | null;
      recipientEmail?: string | null;
      startAt?: string | null;
      endAt?: string | null;
    } | null;
  }>;
  actionRequired: {
    rejectedNeedingRevision: number;
    clarificationsRequested: number;
    pendingOver10Days: number;
    draftsNotSent: number;
    missingSignature: number;
  };
  checklist: {
    hasLogo: boolean;
    hasTeamMemberBeyondOwner: boolean;
    hasClient: boolean;
    hasProject: boolean;
    hasTicket: boolean;
  };
  hasData: boolean;
};

export function fetchDashboardData(filters: {
  projectId?: string;
  range: DashboardRange;
  startDate?: string;
  endDate?: string;
}) {
  const query = new URLSearchParams();
  query.set("range", filters.range);
  if (filters.projectId) query.set("projectId", filters.projectId);
  if (filters.startDate) query.set("startDate", filters.startDate);
  if (filters.endDate) query.set("endDate", filters.endDate);
  return apiRequest<DashboardResponse>(`/reports/dashboard?${query.toString()}`, {
    method: "GET",
  });
}
